import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";


const initialState = {
  snackbars: []
};

const enqueueSnackbar = (state, action) => {
  return updateObject(state, {
    snackbars: [
      ...state.snackbars,
      {
      key: action.key,
      ...action.notification
    },],
  });
}

const closeSnackbar = (state, action) => {
  return updateObject(state, {
    snackbars: state.snackbars.map(n => (
      (action.dismissAll || n.key === action.key) ? { ...n, dismissed: true } : { ...n }
    ))
  });
}

const removeSnackbar = (state, action) => {
  return updateObject(state, {
    snackbars: state.snackbars.filter(n => n.key !== action.key)
  });
}


export default function reducer(state = initialState, action) {
  switch(action.type){
    case actionTypes.notifications.ENQUEUE_SNACKBAR:
      return enqueueSnackbar(state,action);
    case actionTypes.notifications.CLOSE_SNACKBAR:
      return closeSnackbar(state, action);
    case actionTypes.notifications.REMOVE_SNACKBAR:
      return removeSnackbar(state, action);
    default:
      return state;
  }
}